import { Box, BoxProps, ModBox, Spacer, SpacerNew, TextNew } from '@jfs/ui-new'
import { useState } from 'react'
import { Switch } from 'react-native'
import { ExpandAddView } from '../../components/ExpandAddView'
import { useStores } from '../../data/store'
import { ApprovalTypes } from '../../utils/constants'
import { MasterApprovals } from '../EntityApprovals/MasterApprovals'
import { EssAuditTrials } from '../EssAuditTrials'

const MerchantPayoutConfigApprovals = () => {
  const { hasAuditAccess, isAccessConfigPriviledged } = useStores((store) => ({
    hasAuditAccess: store.user.getAccessConfig(['sys_control_config', 'audit', 'approval_audit_fetch', 'isAccessible']),
    isAccessConfigPriviledged: store.user.getAccessConfig([
      'sys_control_config',
      'audit',
      'approval_audit_privileged',
      'isAccessible',
    ]),
  }))

  const [isUserApprover, setUserApprover] = useState(false)

  const handleToggle = (val: boolean) => {
    setUserApprover(val)
  }
  return (
    <Box>
      <Box {...styles.container}>
        <ExpandAddView title={'Configuration Approvals'}>
          <MasterApprovals
            type={ApprovalTypes.MERCHANT_PAYOUT}
            title="Merchant payout Config Approvals"
            hideTitle={true}
          />
        </ExpandAddView>
      </Box>
      <Spacer size={16} direction="vertical" />
      <ModBox {...styles.container} show={hasAuditAccess}>
        <ModBox show={!isAccessConfigPriviledged} p={40} align={'center'} justify={'flex-end'} flexDirection={'row'}>
          <TextNew title={'User'} fontFamily={'jiotype-medium'} fontSize={16} color={'BLACK_21'} />
          <SpacerNew direction={'horizontal'} size={12} />
          <Switch onValueChange={handleToggle} value={isUserApprover} />
          <SpacerNew direction={'horizontal'} size={12} />
          <TextNew title={'Approver'} fontFamily={'jiotype-medium'} fontSize={16} color={'BLACK_21'} />
        </ModBox>
        <Spacer direction="vertical" size={24} />
        <ExpandAddView title={'Audit Trail'}>
          <EssAuditTrials type={ApprovalTypes.RISK_CONFIG_MID_AUD_TRIAL} isApprover={isUserApprover} />
        </ExpandAddView>
      </ModBox>
    </Box>
  )
}

export default MerchantPayoutConfigApprovals

const styles = {
  container: {
    backgroundColor: 'WHITE',
  } as BoxProps,
  subcontainer: {
    backgroundColor: 'WHITE',
    underlayColor: 'WHITE',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 16,
  } as BoxProps,
}
